import axios from 'axios'
import {MessageBox, Message} from 'element-ui'
import store from '@/store'
import md5 from 'js-md5';
import {getToken,getRefreshToken} from '@/utils/auth'
import {deepClone} from '@/utils/index'

// create an axios instance
const service = axios.create({
  baseURL: '/api',

  // baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  // timeout: 30000 // request timeout,
});
window.isRefreshing = false
// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    //   config.url = process.env.VUE_APP_BASE_API + config.url;
    let hasToken = getToken()
    let refreshToken = getRefreshToken()
    if (!hasToken && refreshToken) {
      if (!window.isRefreshing) {
        // console.log('刷新token')
        window.isRefreshing = true
        store.dispatch('user/refreshToken', { 'refresh_token': refreshToken })
          .then((res) => {
            window.isRefreshing = false
            hasToken = res.access_token
            refreshToken = res.refresh_token
            config.headers['Authorization'] = 'Bearer ' + hasToken
            return config
          }).catch(() => {
          window.isRefreshing = false
        })
      }
    }
    if (hasToken && !window.isRefreshing) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers['Authorization'] = 'Bearer ' + hasToken
    }
    let timestamp=new Date().getTime();
    let sign=md5(timestamp+'coursezjer_admin');
    config.headers['Timestamp'] = timestamp;
    config.headers['Sign'] = sign;

    /*
    if (config.hasOwnProperty('params') && config.params.hasOwnProperty('page')) {
      let obj = deepClone(config.params);

      obj.page -= 1;
      config.params = obj
    }*/
    return config
  },
  error => {
    // do something with request error
    // console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    // console.log('[axios]',response)

    const res = response.data

    // if the custom code is not 20000, it is judged as an error.
    if ((response.request && response.request.responseType === 'blob') || res.code === "0" || res.code === 'cityZoneDownload') {
      return res
    } else {
      Message({
        dangerouslyUseHTMLString: true,
        message: res.msg || 'Error',
        type: 'error',
        duration: 4 * 1000
      })

      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (res.code === "401" || res.code === "402"|| res.code === "403") {
        // to re-login
        MessageBox.confirm(res.msg || '您已经退出请重新登录', '提示', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          store.dispatch('user/resetToken').then(() => {
            location.reload()
          })
        })
      }
      return Promise.reject(res)
    }
  },
  error => {
    let des = error.response &&
      error.response.data &&
      error.response.data.msg;

    Message({
      message: des || error.message,
      type: 'error',
      duration: 4 * 1000
    });

    switch (error.response && error.response.status) {
      case 401:
        // let accessToken = store.state.user.accessToken;
        // accessToken && store.dispatch('user/refreshToken',
        //   {
        //     refreshToken: accessToken,
        //     src: "dashboard"
        //   }).then((res) => {
        //   location.reload();
        // }).catch(() => {
        //   store.dispatch('user/resetToken').then(() => {
        //     location.reload();
        //   });
        // });
        break;
      default:
        break;
    }
    return Promise.reject(error)
  }
);

export default service
